import React, { useEffect, useRef } from "react";
import MessageBubble from "./MessageBubble";

// WhatsApp-style day separator label.
// Runs client-side, so Date methods here resolve in the viewer's own
// browser timezone automatically.
function formatDaySeparator(unixSeconds) {
  if (!unixSeconds) return "";

  const msgDate = new Date(unixSeconds * 1000);
  const now = new Date();

  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((startOfDay(now) - startOfDay(msgDate)) / 86400000);

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays > 1 && diffDays < 7) {
    return msgDate.toLocaleDateString([], { weekday: "long" });
  }

  const dd = String(msgDate.getDate()).padStart(2, "0");
  const mm = String(msgDate.getMonth() + 1).padStart(2, "0");
  const yy = String(msgDate.getFullYear()).slice(-2);
  return `${dd}/${mm}/${yy}`;
}

export default function MessageList({ messages }) {
  const bottomRef = useRef(null);

  // Scroll to bottom on new message
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div style={styles.list}>
      {messages.length === 0 ? (
        <p style={styles.empty}>No messages yet. Say hello!</p>
      ) : (
        messages.map((msg, i) => {
          const prevMsg = messages[i - 1];
          const showSeparator =
            !prevMsg ||
            (msg.rawTime && prevMsg.rawTime &&
              new Date(prevMsg.rawTime * 1000).toDateString() !==
                new Date(msg.rawTime * 1000).toDateString());

          return (
            <React.Fragment key={msg.id}>
              {showSeparator && (
                <div style={styles.daySeparator}>
                  <span style={styles.daySeparatorLabel}>
                    {formatDaySeparator(msg.rawTime)}
                  </span>
                </div>
              )}
              <MessageBubble msg={msg} />
            </React.Fragment>
          );
        })
      )}
      <div ref={bottomRef} />
    </div>
  );
}

const styles = {
  list: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    background: "#1e1e1eff",
    minHeight: 0,
  },
  empty: {
    textAlign: "center",
    color: "#f7f7f8ff",
    fontSize: 13,
    marginTop: 60,
  },
  daySeparator: {
    display: "flex",
    justifyContent: "center",
    margin: "12px 0",
  },
  daySeparatorLabel: {
    background: "#2a2a2a",
    color: "#8696a0",
    fontSize: "12px",
    fontWeight: 500,
    padding: "5px 12px",
    borderRadius: "8px",
  },
};